<template>
  <el-select
    :key="count"
    v-model="model"
    :disabled="disabled"
    :popper-class="popupClass"
    :clearable="clearable"
    :placeholder="placeholder"
    filterable
    remote
    reserve-keyword
    @visible-change="visibleChange"
    @clear="clearSelect"
    :remote-method="selectRemoteMethod"
    v-loadmore="loadMore"
    @change="changeSelect">
    <el-option v-for="(item,index) in source" :key="index" :label="item[fieldNames.label]" :value="item[fieldNames.value]" />
  </el-select>
</template>

<script>
  import { getAction, postAction } from '../manage';
  import { getObjProperty } from "../util";
  export default {
    name: 'QuerySelect',
    props: {
      clearable: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '输入关键字可检索'
      },
      name: String,
      popupClass: String,
      api: {
        type: [Object, Function],
        default() {
          return {};
        },
      },
      queryParam: {
        type: Object,
        default: () => ({}),
      },
      pageNames: {
        type: [Object, Boolean],
        default: () => {
          return {
            current: 'current',
            pageSize: 'size'
          }
        },
      },
      fieldNames: {
        type: Object,
        default: {
          label: 'name',
          value: 'value',
        },
      },
      totalPath: String,
      dataPath: String,
      resFormat: {
        type: Function,
      },
      handleQueryData: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'changeActive'
    },
    data() {
      return {
        model: '',
        current: 1,
        size: 10,
        total: 0,
        pages: 0,
        source: [],
        keyword: '',
        loading: false,
      }
    },
    created(){
      if(!this.resDataPath){
        throw new Error("请配置esQuerySelect组件-接口返回值路径！")
      }
      if(this.isPaged){
        if(!this.resTotalPath){
          throw new Error("请配置esQuerySelect组件分页-total返回值路径！")
        }
      }
    },
    computed: {
      resTotalPath() {
        return this.totalPath || window.Vue.prototype.$ESFORMTABLE.totalPath;
      },
      resDataPath() {
        return this.dataPath || window.Vue.prototype.$ESFORMTABLE.dataPath;
      },
      isPaged(){
        return !(typeof this.pageNames === 'boolean' && !this.pageNames);
      }
    },
    watch: {

    },
    methods: {
      reset() {
        this.model = "";
        this.keyword = "";
        this.current = 1;
        this.source = [];
      },
      clearSelect() {
        this.reset();
        this.getData();
      },
      changeSelect(value){
        this.$emit("changeActive", value);
      },
      visibleChange(v) {

      },
      loadMore() {
        if(this.isPaged && this.current <= this.pages){
          this.current++;
          this.getData();
        }
      },
      getData(sus) {
        this.loading = true;
        if(this.loading) {
          let queryParam = { ...this.queryParam };
          //关键字检查
          let baseParam = {
            [this.name]: this.keyword,
          };
          if(this.isPaged){
            baseParam[this.pageNames.current] = this.current;
            baseParam[this.pageNames.pageSize] = this.size;
          }
          const action = this.api.type ? postAction : getAction; //默认get
          let tableAction = this.api instanceof Function
            ? this.api({
              ...queryParam,
              ...baseParam,
            })
            : action(`${this.api.url}`, {
              ...queryParam,
              ...baseParam,
            });
          var temp = [];
          tableAction.then(response => {
            this.loading = false;
            let result  = getObjProperty(response, this.resDataPath);
            let total = getObjProperty(response, this.resTotalPath());
            this.pages = Math.ceil(total / this.size);
            if(this.resFormat){
              result = this.resFormat(result);
            }
            result = result.filter(v => {
              var str = JSON.stringify(v);
              if(temp.includes(str)){
                return false
              }else{
                temp.push(str);
                return true
              }
            });
            if(this.current === 1 || !this.isPaged) {
              this.source = result;
            }else {
              this.source = this.source.concat(result);
            }
            sus && sus();
          });
        }
      },
    }
  }
</script>

<style>

</style>
